import React, { useRef } from 'react';
import { Row, Col, List, Tag } from 'antd';
import { isRecentAndProcessingInference } from '../../../lib/util/processing';
import { useInterval } from '../../../lib/useInterval';
import { getTestFile } from '../../../lib/api/aws-api';
import { ModalSubTitle } from '../../../components/text/Titles';
import BatchUploader from '../../../common/BatchUploader';
import { InferenceFile } from '../../../types';
import { CONFIG } from '../../../config/Config';
import { Icon } from '@ant-design/compatible';

type Props = {
  flowName: string;
  modelId: number;
  onInferenceListUpdated: (inferenceList: InferenceFile[]) => any;
  inferenceList: InferenceFile[];
  hide?: boolean;
};

const UploadMultiContainer = (props: Props) => {
  const { flowName, modelId, onInferenceListUpdated, inferenceList, hide } = props;

  const inferenceIds = useRef(inferenceList.map(inference => inference.id));
  console.log('UPLOAD MULTI CONTAINER: model id ' + modelId);

  useInterval(async () => {
    try {
      updateInferenceListStatus();
    } catch (e) {}
  }, 2000);

  const onBatchUploaded = (batchInferenceIds: string[]) => {
    inferenceIds.current = inferenceIds.current.concat(batchInferenceIds);
    updateInferenceListStatus();
  };

  const updateInferenceListStatus = async () => {
    await Promise.all(
      inferenceIds.current.map(async item => {
        const inference = inferenceList && inferenceList.find(inference => inference.id === item);
        return !!!inference || isRecentAndProcessingInference(inference) ? await getTestFile(item) : inference;
      })
    ).then(results => {
      onInferenceListUpdated(results);
    });
  };

  const getStatus = (status: string) => {
    if (status === 'FINISHED') {
      return (
        <Tag color="green" style={{ fontSize: 14, marginRight: '0px' }}>
          Analysed
        </Tag>
      );
    } else if (status === 'ERROR') {
      return (
        <Tag color="red" style={{ fontSize: 14, marginRight: '0px' }}>
          Failed
        </Tag>
      );
    } else if (status === 'PROCESSING') {
      return (
        <Tag color="orange" style={{ fontSize: 14, marginRight: '0px' }}>
          <Icon type="loading" style={{ color: '#FA531C' }} /> Analysing...
        </Tag>
      );
    }
  };

  return (
    <div style={hide ? { display: 'none' } : {}}>
      <div style={{ marginBottom: '25px' }}>
        <BatchUploader
          modelId={modelId}
          multiple={true}
          getPresignedParams={{ customer: CONFIG.multiflow.customer, flowName: flowName }}
          getPresignedUrl={'/api/generate-presigned-urls'}
          onBatchUploaded={onBatchUploaded}
          isMultiFlow={true}
        />
      </div>
      <ModalSubTitle>Uploaded documents</ModalSubTitle>
      <List
        itemLayout="horizontal"
        dataSource={inferenceList}
        renderItem={inference => (
          <List.Item>
            <List.Item.Meta
              avatar={<Icon type="file-pdf" />}
              title={
                <span
                  style={{
                    color: inference.status === 'FINISHED' ? '#00b9ff' : '999',
                  }}>
                  {inference.fileName}
                </span>
              }
            />
            <Row>
              <Col>{getStatus(inference.status)}</Col>
            </Row>
          </List.Item>
        )}
      />
    </div>
  );
};

export default UploadMultiContainer;
